const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
  const revealSelectors = [
    '.product-card',
    '.collection-card',
    '#shopify-section-media_with_content_philosophy .media-with-content__content',
    '#shopify-section-testimonials_section .group-block .group-block',
    '#shopify-section-collection_showcase .group-block .group-block',
    '#shopify-section-manifesto_statement h2',
  ];

  const revealElements = document.querySelectorAll(revealSelectors.join(','));

  if (revealElements.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    for (const element of revealElements) {
      element.classList.add('scroll-reveal');
      observer.observe(element);
    }
  }

  const heroContainer = document.querySelector('.hero__container');

  if (heroContainer) {
    let ticking = false;

    const applyParallax = () => {
      const rect = heroContainer.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const offset = Math.max(-40, Math.min(40, rect.top * -0.08));
        heroContainer.style.transform = `translateY(${offset}px)`;
      }
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(applyParallax);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
}
